// tabs.js
;(() => {
    const tabActiveClass = 'tab--active'
    const contentActiveClass = 'tabs-content__section--active'
    const tabsButtons = document.querySelectorAll('.tabs-buttons')

    tabsButtons.forEach(buttons => {
        const groupName = buttons.dataset.tabsGroup
        const initIndex = buttons.dataset.tabsInitIndex
        const content = document.querySelectorAll(`.tabs-content[data-tabs-group="${groupName}"] > .tabs-content__section`)

        const tabs = Array.from(buttons.querySelectorAll('.tabs-buttons__tab'))
        
        tabs.forEach(tab => {
            if (tab) {
                tab.addEventListener('click', () => {
                    if (!tab.classList.contains(tabActiveClass)) {
                        resetTabs(tabs, content)
                        const index = tabs.indexOf(tab)
                        tab.classList.add(tabActiveClass)
                        content[index].classList.add(contentActiveClass)
                        const tabsEvent = new Event('tabs-update')
                        tabsEvent.collection = buttons
                        tabsEvent.activeTab = tab
                        tabsEvent.activeIndex = index
                        buttons.dispatchEvent(tabsEvent)
                    } 
                })
            }
        })

        tabs[initIndex].click()
    })

    function resetTabs(tabs, content) {
        tabs.forEach(tab => {
            if (tab) {
                tab.classList.remove(tabActiveClass)
            }
        })
        content.forEach(cnt => {
            if (cnt) {
                cnt.classList.remove(contentActiveClass)
            }
        })
    }
})();